/* global.js – Edgar Russ Theme */

(function () {
  'use strict';

  // ============================================================
  // Scroll reveal – IntersectionObserver on all .reveal elements
  // ============================================================
  function initReveal() {
    const els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach((el) => observer.observe(el));
  }

  // ============================================================
  // Trap focus in mobile nav drawer
  // ============================================================
  function initMobileNavA11y() {
    const nav = document.getElementById('MobileNav');
    if (!nav) return;

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
      }
    });
  }

  // ============================================================
  // Cart count – update via Shopify Cart API on page load
  // ============================================================
  function updateCartCount() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const badge = document.querySelector('.cart-count-bubble');
        if (!badge) return;
        if (cart.item_count > 0) {
          badge.textContent = cart.item_count;
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      })
      .catch(() => {});
  }

  // ============================================================
  // Init
  // ============================================================
  document.addEventListener('DOMContentLoaded', () => {
    initReveal();
    initMobileNavA11y();
    updateCartCount();
  });
})();
